<script lang="ts">
	import Markets from '$lib/portfolio/Markets.svelte';
</script>

<section class="w-full max-w-screen-2xl mx-auto">
	<Markets />
</section>
